__webpack_require__.p = "https://oss-assets.amberstudent.cn/amber-user-website/VP1-8.54.31-eac1-amber-user-website-prod-hk-1896/assets/";